import { GuidedTourAudience } from '../models/guide/guided-tour.model';

const STORAGE_PREFIX = 'caremo_tour_completed_';
const PROMPT_PREFIX = 'caremo_tour_prompt_';
const GLOBAL_DISABLE_KEY = 'caremo_tours_disabled';

export type TourPromptStatus = 'dismissed' | 'accepted';

export function hasCompletedTour(audience: GuidedTourAudience): boolean {
  if (typeof localStorage === 'undefined') return false;
  return localStorage.getItem(`${STORAGE_PREFIX}${audience}`) === 'true';
}

export function hasDisabledAllTours(): boolean {
  if (typeof localStorage === 'undefined') return false;
  return localStorage.getItem(GLOBAL_DISABLE_KEY) === 'true';
}

export function getTourPromptStatus(audience: GuidedTourAudience): TourPromptStatus | null {
  if (typeof localStorage === 'undefined') return null;
  const value = localStorage.getItem(`${PROMPT_PREFIX}${audience}`);
  return value === 'dismissed' || value === 'accepted' ? value : null;
}

export function hasAnsweredTourPrompt(audience: GuidedTourAudience): boolean {
  return getTourPromptStatus(audience) !== null;
}

/** @deprecated Use shouldShowTourPrompt instead */
export function shouldAutoStartTour(audience: GuidedTourAudience): boolean {
  return shouldShowTourPrompt(audience);
}

export function shouldShowTourPrompt(audience: GuidedTourAudience): boolean {
  if (hasDisabledAllTours()) return false;
  if (hasCompletedTour(audience)) return false;
  if (hasAnsweredTourPrompt(audience)) return false;
  return true;
}

export function markTourPromptDismissed(audience: GuidedTourAudience): void {
  localStorage.setItem(`${PROMPT_PREFIX}${audience}`, 'dismissed');
}

export function markTourPromptAccepted(audience: GuidedTourAudience): void {
  localStorage.setItem(`${PROMPT_PREFIX}${audience}`, 'accepted');
}

export function markTourCompleted(audience: GuidedTourAudience): void {
  localStorage.setItem(`${STORAGE_PREFIX}${audience}`, 'true');
}

export function markAllToursDisabled(): void {
  localStorage.setItem(GLOBAL_DISABLE_KEY, 'true');
}

export function resetTourCompletion(audience: GuidedTourAudience): void {
  localStorage.removeItem(`${STORAGE_PREFIX}${audience}`);
}

export function resetTourPrompt(audience: GuidedTourAudience): void {
  localStorage.removeItem(`${PROMPT_PREFIX}${audience}`);
}

export function resetAllTourPreferences(): void {
  localStorage.removeItem(GLOBAL_DISABLE_KEY);
  (['patient', 'provider', 'search'] as GuidedTourAudience[]).forEach(audience => {
    resetTourCompletion(audience);
    resetTourPrompt(audience);
  });
}
